module.exports = __webpack_public_path__ + "img/shata_yes.41ad3688.png";